import {
    madnes_get_alpha, madnes_get_angle,
    madnes_get_pos_x, madnes_get_pos_y, madnes_get_scale_x,
    madnes_get_scale_y,
    madnes_set_alpha,
    madnes_set_angle, madnes_set_cstm_val, madnes_set_img_center, madnes_set_pos,
    madnes_set_scale
} from "../framework/src/engine/madnes/madnes_object";
import {
    madnes_add_win,
    madnes_fullscreen_disable, madnes_fullscreen_enable,
    madnes_get_mouse_x,
    madnes_money_to_coin
} from "../framework/src/engine/madnes/madnes";
import {madnes_tween_func, madnes_tween_to} from "../framework/src/engine/madnes/madnes_tween";
import {fps, he, wi, server_result, systemConfig} from "../framework/src/engine/madnes/madnes_variables";
import {
    madnes_anim_is_playing,
    madnes_anim_loop, madnes_anim_play,
    madnes_anim_stop,
    madnes_start_coin, madnes_stop_coin
} from "../framework/src/engine/madnes/madnes_anims";
import {madnes_alpha_to, madnes_move_to} from "../framework/src/engine/madnes/madnes_render";
import {madnes_audio_loop, madnes_audio_play, madnes_audio_stop} from "../framework/src/engine/madnes/madnes_audio";
import {madnes_set_text} from "../framework/src/engine/madnes/madnes_text";
import {
    result_control_pos,
    set_from_bonus,
    set_result_control_pos,
    set_win_anim_played,
    stars_result_control_part
} from "./stars_core";
import {cylinder_pos} from "./stars_config";
import { CONFIG_PARAMS, MODES } from "../framework/src/system/SystemConfig";

export function stars_result_control_mystery_1(win_set)
{
    // madnes_hide_btns();
    var playing = false;
    for(var pos in win_set.position)
    {
        if(madnes_anim_is_playing("reels_bufer_" + win_set.position[pos][0] + "_S" + ( 2 - win_set.position[pos][1] )))
        {
            playing = true;
        }
    }
    if(playing)
    {
        setTimeout(function() {
            stars_result_control_mystery_1(win_set);
        }, 100);
    }
    else
    {
        for(var i = 0; i <= 2; i++)
        {
            if(madnes_get_alpha("bonus_bg_"+i) == 0)
            {
                madnes_alpha_to("bonus_bg_" + i, 1, 200);
            }
        }
        setTimeout(function() {
            stars_result_control_mystery_2(win_set);
        }, 1000 / fps);
    }
}

function stars_result_control_mystery_2(win_set)
{
    for(var pos in win_set.position)
    {
        madnes_anim_play("reels_bufer_" + win_set.position[pos][0] + "_S" + ( 2 - win_set.position[pos][1] ), "anim", 30);
        madnes_set_pos("reels_bufer_myst_" + win_set.position[pos][0], cylinder_pos[win_set.position[pos][0]], madnes_get_pos_y("reels_bufer_" + win_set.position[pos][0] + "_S" + ( 2 - win_set.position[pos][1] )));
        madnes_set_scale("reels_bufer_myst_" + win_set.position[pos][0], 1,  madnes_get_scale_y("reels_bufer_" + win_set.position[pos][0] + "_S" + ( 2 - win_set.position[pos][1] )));
    }

    setTimeout(function() {
        stars_result_control_mystery_3(win_set);
    }, 1000 / fps);
}

function stars_result_control_mystery_3(win_set)
{
    var playing = false;
    for(var pos in win_set.position)
    {
        if(madnes_anim_is_playing("reels_bufer_" + win_set.position[pos][0] + "_S" + ( 2 - win_set.position[pos][1] )))
        {
            playing = true;
        }
    }
    if(playing)
    {
        setTimeout(function() {
            stars_result_control_mystery_3(win_set);
        }, 1000 / fps);
    }
    else
    {
        for(var pos in win_set.position)
        {
            madnes_set_alpha("reels_bufer_" + win_set.position[pos][0] + "_S" + ( 2 - win_set.position[pos][1] ), 0);
            madnes_set_alpha("reels_bufer_myst_" + win_set.position[pos][0], 1);
        }
        stars_result_control_mystery_4(win_set);
    }
}

function stars_result_control_mystery_4(win_set)
{
    var all_ok = true;
    for(var pos in win_set.position)
    {
        var scale = madnes_get_scale_y("reels_bufer_myst_" + win_set.position[pos][0]);
        if(scale < 1)
        {
            all_ok = false;
            scale = scale * 1 + 0.01;
            if(scale > 1)
            {
                scale = 1;
            }
            madnes_set_scale("reels_bufer_myst_" + win_set.position[pos][0], 1, scale);
        }
    }

    if(all_ok)
    {
        setTimeout(function() {
            stars_result_control_mystery_5_fst = true;
            stars_result_control_mystery_5(win_set);
        }, 1000 / fps);
    }
    else
    {
        setTimeout(function() {
            stars_result_control_mystery_4(win_set);
        }, 1000 / fps);
    }
}

var stars_result_control_mystery_5_fst = true;
function stars_result_control_mystery_5(win_set)
{
    if(stars_result_control_mystery_5_fst == true)
    {
        stars_result_control_mystery_5_fst = false;
        for(var pos in win_set.position)
        {
            madnes_move_to("reels_bufer_myst_" + win_set.position[pos][0], wi / 2, he / 2, 1000);
        }
    }

    var all_ok = true;
    for(var pos in win_set.position)
    {
        var pos_x = madnes_get_pos_x("reels_bufer_myst_" + win_set.position[pos][0]);
        var pos_y = madnes_get_pos_y("reels_bufer_myst_" + win_set.position[pos][0]);

        if(!(pos_x == wi / 2 && pos_y == he / 2))
        {
            all_ok = false;
        }
    }

    if(all_ok)
    {
        stars_result_control_mystery_6(win_set, 0);
    }
    else
    {
        setTimeout(function() {
            stars_result_control_mystery_5(win_set);
        }, 1000 / ( fps / 2 ) );
    }
}

function stars_result_control_mystery_6(win_set, pos)
{
    if(pos > 0)
    {
        var scale = madnes_get_scale_x("wing_l") * 1;

        madnes_set_scale("wing_l", scale, scale);
        madnes_set_scale("wing_r", scale, scale);
    }

    if(pos == 0)
    {
        madnes_anim_loop("wing_l", "anim");
        madnes_anim_loop("wing_r", "anim");

        madnes_set_alpha("mystery_symbol", 0);
        madnes_set_alpha("wing_l", 0);
        madnes_set_alpha("wing_r", 0);


        madnes_set_img_center("mystery_symbol", 0.5, 0.5);

        madnes_set_img_center("wing_l", 0.9, 0.5);
        madnes_set_img_center("wing_r", 0.1, 0.5);

        madnes_set_scale("mystery_symbol", 0.175, 0.175);

        madnes_set_scale("wing_l", 4 * 0.345, 4 * 0.345);
        madnes_set_scale("wing_r", 4 * 0.345, 4 * 0.345);

        madnes_set_pos("mystery_symbol", wi / 2, he / 2);

        madnes_set_pos("wing_l", wi / 2 - 70, he / 2);
        madnes_set_pos("wing_r", wi / 2 + 70, he / 2);

        madnes_set_pos("bonus_background", 0, 0);
        madnes_set_alpha("bonus_background", 0);

        madnes_set_cstm_val("wing_l", "+");
    }
    else if(pos < 20)
    {
        var step = 0.05;

        madnes_set_alpha("reels_bufer_myst_0", madnes_get_alpha("reels_bufer_myst_0") * 1 - step);
        madnes_set_alpha("reels_bufer_myst_1", madnes_get_alpha("reels_bufer_myst_1") * 1 - step);
        madnes_set_alpha("reels_bufer_myst_2", madnes_get_alpha("reels_bufer_myst_1") * 1 - step);

        madnes_set_alpha("mystery_symbol", madnes_get_alpha("mystery_symbol") * 1 + step);
        madnes_set_alpha("wing_l", madnes_get_alpha("wing_l") * 1 + step);
        madnes_set_alpha("wing_r", madnes_get_alpha("wing_r") * 1 + step);
    }
    else
    {
        var step = 0.003 * 3;
        var step2 = 0.008 * 4 * 3;
        var scale = madnes_get_scale_x("mystery_symbol") * 1 + step;
        var scale_l = madnes_get_scale_x("wing_l") * 1 + step2;
        var scale_r = madnes_get_scale_x("wing_r") * 1 + step2;

        madnes_set_scale("mystery_symbol", scale, scale);
        madnes_set_scale("wing_l", scale_l, scale_l);
        madnes_set_scale("wing_r", scale_r, scale_r);

        madnes_set_pos("wing_l", ( wi / 2 ) - ( 70 + ( ( ( pos - 20 ) / 10 ) * 40 ) ), he / 2);
        madnes_set_pos("wing_r", ( wi / 2 ) + ( 70 + ( ( ( pos - 20 ) / 10 ) * 40 ) ), he / 2);

    }

    if(pos > 30)
    {
        var bon_alp = madnes_get_alpha("bonus_background") * 1;
        if(bon_alp < 1)
        {
            bon_alp = bon_alp + 0.05;
            madnes_set_alpha("bonus_background", bon_alp);
        }
    }

    if(pos == 40)
    {
        madnes_set_pos("mystery_wheel", wi / 2, he / 4 * 3);
        madnes_set_pos("mystery_wheel_center", wi / 2, he / 4 * 3);
        madnes_set_pos("mystery_arrow_left", wi / 2, he / 4 * 3);
        madnes_set_pos("mystery_arrow_right", wi / 2, he / 4 * 3);
        madnes_set_pos("mystery_arrow_center", wi / 2, he / 4 * 3);
        madnes_set_pos("mystery_hand", wi / 2, he / 4 * 3);

        madnes_set_alpha("mystery_wheel", 0);
        madnes_set_alpha("mystery_wheel_center", 0);
        madnes_set_alpha("mystery_arrow_left", 0);
        madnes_set_alpha("mystery_arrow_right", 0);
        madnes_set_alpha("mystery_arrow_center", 0);
        madnes_set_alpha("mystery_hand", 0);

        stars_result_control_mystery_7_hand_move_timer = setInterval(stars_result_control_mystery_7_hand_move, 1000 / fps);
        stars_result_control_mystery_autostart_timer = setTimeout(stars_result_control_mystery_autostart, systemConfig.get(CONFIG_PARAMS.MODE) === MODES.REPLAY ? 3000 : 60 * 1000);
        madnes_fullscreen_disable();

    }

    if(pos > 40 && madnes_get_alpha("mystery_wheel") < 1)
    {
        step = 0.05;
        madnes_set_alpha("mystery_wheel", madnes_get_alpha("mystery_wheel") * 1 + step);
        madnes_set_alpha("mystery_wheel_center", madnes_get_alpha("mystery_wheel_center") * 1 + step);
        madnes_set_alpha("mystery_arrow_left", madnes_get_alpha("mystery_arrow_left") * 1 + step);
        madnes_set_alpha("mystery_arrow_right", madnes_get_alpha("mystery_arrow_right") * 1 + step);
        madnes_set_alpha("mystery_arrow_center", madnes_get_alpha("mystery_arrow_center") * 1 + step);
        madnes_set_alpha("mystery_hand", madnes_get_alpha("mystery_hand") * 1 + step);
    }

    if(pos > 50)
    {
        var step = 0.025;
        madnes_set_alpha("mystery_symbol", madnes_get_alpha("mystery_symbol") * 1 - step);
        madnes_set_alpha("wing_l", madnes_get_alpha("wing_l") * 1 - step);
        madnes_set_alpha("wing_r", madnes_get_alpha("wing_r") * 1 - step);
    }

    if(pos <= 100)
    {
        setTimeout(function() {
            stars_result_control_mystery_6(win_set, pos * 1 + 1);
        }, 1000 / fps * 1);
    }
    else
    {
        stars_mystery_rotate_input_lock = 0;

        madnes_set_alpha("mystery_symbol", 0);
        madnes_set_alpha("wing_l", 0);
        madnes_set_alpha("wing_r", 0);

        madnes_set_pos("mystery_symbol", -9999, -9999);
        madnes_set_pos("wing_l", -9999, -9999);
        madnes_set_pos("wing_r", -9999, -9999);

        madnes_anim_stop("wing_l");
        madnes_anim_stop("wing_r");

        //background_pre_mystery_timeout = setTimeout('madnes_audio_loop("background_pre_mystery")', 500);

        madnes_audio_stop("background_pre_mystery");
        madnes_audio_loop("background_mystery");

    }
}

var stars_result_control_mystery_autostart_timer = null;
function stars_result_control_mystery_autostart()
{
    stars_result_control_mystery_autostart_timer = null;
    stars_mystery_stop_hand();
    stars_mystery_start_rotate();
}

var background_pre_mystery_timeout = null;

var stars_result_control_mystery_7_hand_move_timer = null;
var stars_result_control_mystery_7_hand_move_dir = 1;
function stars_result_control_mystery_7_hand_move()
{
    var ang = madnes_get_angle("mystery_hand");
    if(stars_result_control_mystery_7_hand_move_dir == 1)
    {
        if(ang * 1 < 60)
        {
            ang = ang * 1 + 2;
        }
        else
        {
            stars_result_control_mystery_7_hand_move_dir = -1;
        }
    }
    else
    {
        if(ang * 1 > -60)
        {
            ang = ang * 1 - 2;
        }
        else
        {
            stars_result_control_mystery_7_hand_move_dir = 1;
        }
    }
    madnes_set_angle("mystery_hand", ang);
}

var stars_mystery_mouse_in = -1;
var stars_mystery_rotate_dir = 0;
var stars_mystery_rotate_input_lock = 1;
var stars_mystery_rotate_fst_control_interval = null;
export function stars_mystery_stop_hand()
{
    if(stars_mystery_rotate_input_lock == 0)
    {
        if(stars_result_control_mystery_autostart_timer != null)
        {
            clearTimeout(stars_result_control_mystery_autostart_timer);
            stars_result_control_mystery_autostart_timer = null;
        }

        stars_mystery_rotate_input_lock = 2;
        clearTimeout(stars_result_control_mystery_7_hand_move_timer);
        stars_result_control_mystery_7_hand_move_timer = null;
        madnes_set_angle("mystery_hand", 0);
        madnes_set_pos("mystery_hand", -9999, -9999);
        stars_mystery_mouse_in = madnes_get_mouse_x();
        stars_mystery_rotate_dir = 0;
        stars_mystery_rotate_fst_control_interval = setInterval(stars_mystery_fst_rotate, 1000 / fps);
    }
}

function stars_mystery_fst_rotate()
{
    var ang = madnes_get_mouse_x() - stars_mystery_mouse_in;
    ang = ang / (wi / 2);
    ang = ang * 60;

    madnes_set_angle("mystery_wheel", ang);
}

// Pomocne funkce

var sinusoidal_in_out = madnes_tween_func("sinusoidal_in_out");
var sinusoidal_out = madnes_tween_func("sinusoidal_out");
function star_end1(k)
{
    var k2 = k;
    var c1 = --k2 * k2 * k2 + 1;

    var end = 0.2;

    if(k >= 1 - end)
    {
        var e = 1 - end;
        var p1 = end / 2;

        var pr = 0;

        if(k - e < p1)
        {
            pr = k - e;
        }
        else
        {
            pr = k - e;

            pr = pr - ( pr - ( p1 / 1 ) ) * 2;
        }

        pr = pr * 2;

        var X0 = 5;

        pr = sinusoidal_in_out(pr * X0) / X0;

        c1 = c1 * 1 + 0.025 * pr;
    }

    return c1;
}

function star_end2(k)
{
    var k2 = k;
    var c1 = --k2 * k2 * k2 + 1;

    var end = 0.25;

    if(k >= 1 - end)
    {
        var e = 1 - end;
        var p1 = end / 2;

        var pr = 0;

        if(k - e < p1)
        {
            pr = k - e;

            var X0 = 4;
            //pr = sinusoidal_out(pr * X0) / X0;

        }
        else
        {
            pr = k - e;

            pr = pr - ( pr - ( p1 / 1 ) ) * 2;
        }

        var X0 = 8;
        pr = sinusoidal_in_out(pr * X0) / X0;

        c1 = c1 * 1 - 0.020 * pr;
    }

    return c1;
}

// Pomocne funkce konec

var stars_rotate_tween = null;
var stars_rotate_tween_aud = null;
export function stars_mystery_start_rotate()
{
    if(stars_mystery_rotate_input_lock == 2)
    {
        setTimeout(madnes_fullscreen_enable, 1000);

        clearInterval(stars_mystery_rotate_fst_control_interval);
        stars_mystery_rotate_fst_control_interval = null;
        stars_mystery_rotate_input_lock = 1;

        madnes_set_pos("mystery_arrow_left", -9999, -9999);
        madnes_set_pos("mystery_arrow_right", -9999, -9999);

        if(stars_mystery_mouse_in > madnes_get_mouse_x())
        {
            stars_mystery_rotate_dir = -1;
        }
        else
        {
            stars_mystery_rotate_dir = 1;
        }

        var multi = server_result.result.bonusWin / server_result.result.bet;
        var end = stars_mystery_wheel_pos_revers[multi][ Math.floor( Math.random() * stars_mystery_wheel_pos_revers[multi].length ) ];
        if(end < 0)
        {
            end = end + 360;
        }
        if(stars_mystery_rotate_dir < 0)
        {
            end = 360 - end;
        }


        var rots = Math.ceil( Math.random() * 2 ) + 1;
        var time = rots * 3000;
        rots = rots * 360;

        start_bonus_click_stepclick = 360 / 10;
        setTimeout(function(){
            start_bonus_click_stepclick = 360 / 20;
        }, time / 2);

        rots = rots * 1 + end * 1;

        rots = rots * stars_mystery_rotate_dir;

        start_bonus_click_pos = 0;
        stars_rotate_tween_aud = 100;
        setTimeout(start_bonus_click, stars_rotate_tween_aud);

        /*
        stars_rotate_tween = madnes_tween_to("mystery_wheel", { angle: rots }, {
                easing: "cubic_out",
                duration: time
            }
        );

        var tend = time * 0.55;

        setTimeout(function(rots, tend) {

            // Slow

            stars_rotate_tween.stop();

            stars_rotate_tween_aud = -9999;

            madnes_audio_play("mystery_rotation");

            madnes_tween_to("mystery_wheel", { angle: rots }, {
                    easing: "elastic_out",
                    duration: tend,
                    callback: function() {

                        // END
                        madnes_audio_play("mystery_rotation");

                        stars_rotate_tween = null;

                        stars_mystery_win1(0);
                    }
                }
            );

        }.bind(this, rots, tend), time * 0.75);

        */



        var eas = null;
        switch(Math.floor(Math.random() * 2))
        {
            case 0:
                eas = star_end1;
                break;
            case 1:
                eas = star_end2;
                break;
            default:
                console.log("Easing 0");
                eas = star_end1;
                break;
        }

        madnes_tween_to("mystery_wheel", {
                angle: rots
            }, {
                easing: eas,
                duration: time,
                callback: function() {

                    stars_rotate_tween_aud = -9999;

                    madnes_audio_play("bonus_Wheel");

                    stars_rotate_tween = null;

                    setTimeout(stars_mystery_win1.bind(this,0), 250);


                    /*
                    madnes_alpha_to("wheel_dark", 1, 400);
                    madnes_alpha_to("multiplier_dark_all", 0, 400);

                    ninestars_reel_shines2_en = 1;
                    ninestars_reel_shines2();
                    madnes_alpha_to("arrows", 1, 250);

                    madnes_fullscreen_disable();
                    ninestars_mystery_wheel_btn_enabled2 = 1;

                    madnes_alpha_to("bonus_btn_spin", 1, 400);
                    madnes_alpha_to("bonus_btn_spin_pressed", 1, 400, ninestars_bonus_middle3);
                    ninestars_rotated2 = 0;

                    madnes_audio_fade_out("Wheel_bg1", 400);
                    madnes_audio_play("Wheel_bg2");

                    autostart_timer = setTimeout(function() {
                        ninestars_rotate_start1();
                        ninestars_rotate_start2();
                    }, 15 * 1000);
                    */
                }
            }
        );


    }
}

var start_bonus_click_pos = 0;
var start_bonus_click_stepclick = 360 / 10;
function start_bonus_click()
{
    if(stars_rotate_tween_aud > 0)
    {
        // Zvuk / cvakání

        var curr = Math.abs(madnes_get_angle("mystery_wheel"));
        if(curr - start_bonus_click_pos >= start_bonus_click_stepclick)
        {
            start_bonus_click_pos = start_bonus_click_stepclick * Math.floor( curr / start_bonus_click_stepclick )
            //if(!madnes_audio_is_playing("bonus_Wheel"))
            //{
            madnes_audio_play("bonus_Wheel");
            //}
        }

        //madnes_audio_play("mystery_rotation");
        //stars_rotate_tween_aud = stars_rotate_tween_aud * 1 + 4;
        //setTimeout(start_bonus_click, stars_rotate_tween_aud);

        setTimeout(start_bonus_click, 1000 / fps);
    }
}

var stars_mystery_wheel_pos_revers = new Array();
stars_mystery_wheel_pos_revers[10] = new Array();
stars_mystery_wheel_pos_revers[10][0] = -36;
stars_mystery_wheel_pos_revers[10][1] = 90;
stars_mystery_wheel_pos_revers[10][2] = -108;
stars_mystery_wheel_pos_revers[10][3] = -180;

stars_mystery_wheel_pos_revers[20] = new Array();
stars_mystery_wheel_pos_revers[20][0] = 126;
stars_mystery_wheel_pos_revers[20][1] = 54;
stars_mystery_wheel_pos_revers[20][2] = -72;
stars_mystery_wheel_pos_revers[20][3] = -144;

stars_mystery_wheel_pos_revers[40] = new Array();
stars_mystery_wheel_pos_revers[40][0] = -126;
stars_mystery_wheel_pos_revers[40][1] = -18;

stars_mystery_wheel_pos_revers[60] = new Array();
stars_mystery_wheel_pos_revers[60][0] = 36;
stars_mystery_wheel_pos_revers[60][1] = 144;

stars_mystery_wheel_pos_revers[80] = new Array();
stars_mystery_wheel_pos_revers[80][0] = 72;
stars_mystery_wheel_pos_revers[80][1] = -90;

stars_mystery_wheel_pos_revers[100] = new Array();
stars_mystery_wheel_pos_revers[100][0] = 0;
stars_mystery_wheel_pos_revers[100][1] = -162;

stars_mystery_wheel_pos_revers[200] = new Array();
stars_mystery_wheel_pos_revers[200][0] = 108;

stars_mystery_wheel_pos_revers[300] = new Array();
stars_mystery_wheel_pos_revers[300][0] = -54;

stars_mystery_wheel_pos_revers[400] = new Array();
stars_mystery_wheel_pos_revers[400][0] = 162;

stars_mystery_wheel_pos_revers[500] = new Array();
stars_mystery_wheel_pos_revers[500][0] = 18;

var stars_mystery_win_text_step = 0;
function stars_mystery_win1(pos)
{
    if(pos == 0)
    {
        madnes_add_win(server_result.result.bonusWin * 1); //win = win * 1 + server_result.result.bonusWin * 1;
        madnes_start_coin();
        stars_mystery_win_text_step = 0;
        madnes_audio_stop("background_mystery");
        madnes_audio_play("win");

        madnes_set_pos("mystery_win_rect", wi / 2, he / 2);
        madnes_set_alpha("mystery_win_rect", 0);
        madnes_set_img_center("mystery_win_rect", 0.5, 0.54);

        madnes_set_pos("table_bonus_win", wi / 2, he * 1.2);
        madnes_set_alpha("table_bonus_win", 1);
        madnes_set_img_center("table_bonus_win", 0.5, 0.5);

        madnes_set_pos("mystery_sprite_text", wi / 2, he * 1.2);
        madnes_set_alpha("mystery_sprite_text", 1);
        madnes_set_img_center("mystery_sprite_text", 0.5, 0);
        madnes_set_text("mystery_sprite_text", "0");

        madnes_set_alpha("table_bonus_win", 0);
        madnes_set_alpha("mystery_sprite_text", 0);
        madnes_set_pos("table_bonus_win", wi / 2, he / 2);
        madnes_set_pos("mystery_sprite_text", wi / 2, he / 2);
    }

    if(pos > 0 && pos <= 20)
    {
        var step = 0.05;
        var alp = madnes_get_alpha("mystery_win_rect") * 1 + step;
        if(alp > 1)
        {
            alp = 1;
        }
        madnes_set_alpha("mystery_win_rect", alp);
    }

    if(pos > 40 && pos < 94)
    {
        madnes_set_alpha("table_bonus_win", madnes_get_alpha("table_bonus_win") * 1 + 0.05);
        madnes_set_alpha("mystery_sprite_text", madnes_get_alpha("mystery_sprite_text") * 1 + 0.05);
    }

    if(pos > 40 && pos <= 140)
    {
        var sum = madnes_money_to_coin( server_result.result.bonusWin ) * ( ( pos - 40 ) / 100 );
        sum = Math.ceil(sum);
        madnes_set_text("mystery_sprite_text",  sum);
        madnes_audio_play("remittance_A");
    }

    if(pos == 140)
    {
        //win = win * 1 + server_result.result.bonusWin * 1;
        madnes_audio_play("remittance_B");

        madnes_stop_coin();
    }

    if(pos > 180 && pos < 202)
    {
        madnes_set_alpha("table_bonus_win", madnes_get_alpha("table_bonus_win") * 1 - 0.05);
        madnes_set_alpha("mystery_sprite_text", madnes_get_alpha("mystery_sprite_text") * 1 - 0.05);
    }

    if(pos > 230 && pos <= 260)
    {
        madnes_set_alpha("bonus_background", 1 - 0.05 * ( pos - 240 ) );
        madnes_set_alpha("mystery_wheel", 1 - 0.05 * ( pos - 240 ));
        madnes_set_alpha("mystery_wheel_center", 1 - 0.05 * ( pos - 240 ));
        madnes_set_alpha("mystery_arrow_left", 1 - 0.05 * ( pos - 240 ));
        madnes_set_alpha("mystery_win_rect", 1 - 0.05 * ( pos - 240 ));
        madnes_set_alpha("mystery_arrow_right", 1 - 0.05 * ( pos - 240 ));
        madnes_set_alpha("mystery_arrow_center", 1 - 0.05 * ( pos - 240 ));
        madnes_set_alpha("mystery_hand", 1 - 0.05 * ( pos - 240 ));
    }

    if(pos == 210)
    {
        madnes_set_alpha("reels_bufer_0_S0", 1);
        madnes_set_alpha("reels_bufer_0_S1", 1);
        madnes_set_alpha("reels_bufer_0_S2", 1);
        madnes_set_alpha("reels_bufer_1_S0", 1);
        madnes_set_alpha("reels_bufer_1_S1", 1);
        madnes_set_alpha("reels_bufer_1_S2", 1);
        madnes_set_alpha("reels_bufer_2_S0", 1);
        madnes_set_alpha("reels_bufer_2_S1", 1);
        madnes_set_alpha("reels_bufer_2_S2", 1);

        madnes_set_alpha("bonus_bg_0", 0);
        madnes_set_alpha("bonus_bg_1", 0);
        madnes_set_alpha("bonus_bg_2", 0);

        madnes_set_pos("reels_bufer_myst_0", -9999, -9999);
        madnes_set_pos("reels_bufer_myst_1", -9999, -9999);
        madnes_set_pos("reels_bufer_myst_2", -9999, -9999);


    }

    if(pos == 265)
    {
        madnes_set_pos("bonus_background", -9999, -9999);
        madnes_set_pos("mystery_wheel", -9999, -9999);
        madnes_set_pos("mystery_wheel_center", -9999, -9999);
        madnes_set_pos("mystery_arrow_left", -9999, -9999);
        madnes_set_pos("mystery_arrow_right", -9999, -9999);
        madnes_set_pos("mystery_arrow_center", -9999, -9999);
        madnes_set_pos("mystery_hand", -9999, -9999);
        madnes_set_pos("mystery_win_rect", -9999, -9999);
    }

    if(pos < 280)
    {
        setTimeout(stars_mystery_win1.bind(null, ( pos * 1 + 1 ) ), 1000 / fps);
    }
    else
    {
        madnes_set_pos("table_bonus_win", -9999, -9999);
        madnes_set_pos("mystery_sprite_text", -9999, -9999);

        set_win_anim_played(true);

        set_result_control_pos(result_control_pos+1); // result_control_pos++
        set_from_bonus(0);

        stars_result_control_part();

        // madnes_show_btns();
    }
}

